export const API_ENDPOINTS = {
  page_limit: 10,
  shimmer_row_limit: 5,
  shimmer_col_limit: 5,
  modalPageLimit: 10,

  forgot_password: "/auth/forget_password",
  verify_otp: "/auth/verify_otp",
  reset_password: "/auth/reset_password",
  get_customers: "/customer/get",
  get_pages: "/page/get",
  edit_page:"page/edit",
  get_orders: "/orders",
  get_orders_chat: "/orders/chat",
  get_services: "/services",
  get_dashbaord: "/dashbaord",
  get_langauges: "/get/languages",
  get_faqs: "/faq/get",
  update_faqs: "/faq/update",
  get_profile: "/profile",
  update_profile:"profile",
  chat_users:"customer/chat_user_list",
  chat_support_chat_history: "/get/chat_support_chat_history",
  get_cities: "/get/cities",
  forget_password:"forget_password",
  reset_password:"reset_password",
  

  //master=============================================================================================================================
};
